import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { toastConstants } from '../../constants'
import { BLUE, DANGER, BACKGROUND } from '../../styles/colors.style'
import { borderRadius, shadow } from '../../styles/reusable.style'

const getBgColor = (type) => {
	switch (type) {
		case toastConstants.WARNING:
			return BACKGROUND
		case toastConstants.DANGER:
			return DANGER
		case toastConstants.SUCCESS:
		default:
			return BLUE
	}
}

const StyledDiv = styled.div`
	${shadow()};
	display: block;
	border-radius: ${borderRadius};
	background: ${({ type }) => getBgColor(type)};
	height: max-content;
	left: 25%;
	position: fixed;
	top: 10%;
	width: 50%;
	z-index: 5;
	transition: all 3s ease-in-out;

	&.fadeOut {
		display: none;
	}

	@media screen and (max-width: 480px) {
		left: 5%;
		width: 90%;
	}
`

const StyledSpan = styled.span`
	color: white;
	cursor: default;
	display: inline-block;
	font-size: 2rem;
	margin: 10px 15px;
	user-select: none;
`

class Toast extends Component {
	render() {
		const { message, closing } = this.props
		return (
			message && (
				<StyledDiv
					{...this.props}
					className={`animated ${closing ? 'fadeOut' : 'fadeIn'}`}>
					<StyledSpan>
						{typeof message === 'function' ? message() : message}
					</StyledSpan>
				</StyledDiv>
			)
		)
	}
}

const mapStateToProps = ({ toast }) => toast

const connectedComponent = connect(mapStateToProps, null)(Toast)

export { connectedComponent as Toast }
